<template>
  <div>
    <Button color="blue" class="button mb-3" @click="openMainButtonTelegram()">
      <div class="icon">
        <img :src="TelegramButtonIcon" />
      </div>
      {{ $t('modals.auth.singInTelegram') }}
    </Button>
    <Button color="white" class="button mt-4 mb-3" @click="openGoogle()">
      <div class="icon">
        <img :src="GoogleButtonIcon" />
      </div>
      {{ $t('modals.auth.singInGoogle') }}
    </Button>
    <div
      @click="openWebVersionTelegram()"
      class="text-center text-muted web_tg"
    >
      {{ $t('modals.auth.imUsing') }}
      <span class="btn_link">{{ $t('modals.auth.webVersion') }}</span>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { getCookie } from '@/helpers/base/cookie'
import { makeEvent } from '@/helpers/base/amplitude'
import { TELEGRAM_URL } from '@/helpers/variables'
import GoogleButtonIcon from '@/assets/icons/google-icon.svg'
import TelegramButtonIcon from '@/assets/icons/telegram-button.svg'
import Button from '@/components/buttons/Button.vue'
import { api } from '@/helpers/base/api'

// Кнопки входа: Telegram-бот, Google и переход на виджет для web-версии Telegram (шаг 2)
export default {
  data() {
    return {
      TelegramButtonIcon,
      GoogleButtonIcon,
      source: 'web',
      telegramUrl: TELEGRAM_URL,
    }
  },
  components: {
    Button,
  },
  computed: {
    ...mapState(['view']),
    firstViewId() {
      return getCookie('firstViewId')
    },
    urlAuth() {
      return `${this.telegramUrl}?start=authenticate_${this.source}_${
        this.view.viewId
      }${this.firstViewId ? `_${this.firstViewId}` : ''}`
    },
  },
  methods: {
    ...mapMutations('authModule', ['setStep']),
    openMainButtonTelegram() {
      makeEvent('auth popup', {
        button: 'open_telegram',
      })
      window.open(this.urlAuth)
    },
    async openGoogle() {
      try {
        const { pathname } = window.location
        const respond = await api.get(`/auth/google?lastLink=${pathname}`)
        console.log('[auth] /auth/google response:', JSON.stringify(respond))
        if (!respond?.success || !respond?.data) {
          console.error(
            '[auth] в ответе нет data — window.open уйдет на относительный "undefined" (/id/undefined). Ответ подменен/перехвачен (расширение? прокси?)'
          )
        }
        makeEvent('auth popup', {
          button: 'sign_in_google',
        })
        window.open(`${respond.data}`, '_self')
      } catch (err) {
        console.error('[auth] запрос /auth/google не прошел:', err)
      }
    },
    openWebVersionTelegram() {
      this.setStep(2)
      makeEvent('auth popup', {
        button: 'using_web_version',
      })
    },
  },
}
</script>

<style scoped>
.btn_link {
  color: var(--main-color);
}
.icon {
  margin-right: 20px;
}
.button {
  font-weight: bold;
  font-size: 15px;
  line-height: 20px;
  box-shadow: var(--shadow-card);
  width: 100%;
  max-width: 350px;
  margin: auto;
}
.web_tg {
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: var(--text-secondary2);
}
.web_tg span {
  cursor: pointer;
}
</style>
